export default __webpack_public_path__ + "static/media/type_11_6.e5e7ccd2.svg";